
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const AuthRedirect = () => {
  const { user, activeRole, roleReady } = useAuth();
  
  console.log('AuthRedirect: user:', !!user, 'activeRole:', activeRole, 'roleReady:', roleReady);
  
  if (!user) {
    console.log('AuthRedirect: No user, redirecting to home');
    return <Navigate to="/" replace />;
  }
  
  // Wait for role to be determined before redirecting
  if (!roleReady) {
    console.log('AuthRedirect: Role not ready, waiting...');
    return null; // Or a loading spinner
  }
  
  if (activeRole === 'client') {
    console.log('AuthRedirect: Redirecting to client dashboard');
    return <Navigate to="/client-dashboard" replace />;
  } else if (activeRole === 'practitioner') {
    console.log('AuthRedirect: Redirecting to practitioner dashboard');
    return <Navigate to="/practitioner-dashboard" replace />;
  } else if (activeRole === 'admin') {
    console.log('AuthRedirect: Redirecting to admin dashboard');
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  console.log('AuthRedirect: No valid role found, redirecting to home');
  return <Navigate to="/" replace />;
};

export default AuthRedirect;

